<template>
	<div class="row">
    <div class="col-md-12" style="background:var(--blue)"><p class="header-bar">CASH ACTIVITY REPORT</p></div>
		<TableView :col="columns" v-if="showTableView" :getData="getData" :Options="{tblContainerClass:'innerTable-style'}"/>           
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['row','report_date','base_currency'],
  data(){
  	return {
      showTableView: false,
      res: {},
      columns: (() => {
        const cols = [
          { title: 'LCY', field: 'lcy', tdClass:"p1rem"},
          { title: 'Ticker', field: 'tidm' },
          { title: 'Name', field: 'issuer_name'},
          { title: 'Type', field: 'type'},
          { title: 'Quantity', field: 'quantity', tdComp: 'Number', 'floatLength': 2},
          { title: 'Cost Price', field: 'cost_price' , tdComp: 'Number'},
          { title: 'Trade Price', field: 'trade_price', tdComp: 'Number'},
          { title: 'Realized PNL', field: 'realized_pnl', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Deposit/Withdraw', field: 'deposit_withdraw' , tdComp: 'Number', 'floatLength': 2},
          { title: 'FX Rate', field: 'fx_rate', tdComp: 'Number' },
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  mounted() {
      let uri = 'cash_activity_report?account_number='+this.row.account_number+'&report_date='+this.report_date+'&base_cur='+this.base_currency;
      this.call_axios(uri).then(res => {
          this.res = res;
          this.showTableView = true;
      });
  },
  methods: {
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      var result = this.duplicate(this.res);
      result.response.data.result = result.response.data.result.slice(offset, offset+limit);
      return result;
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>